const EDITOR = [
    "reports:view",
    "campaigns:schedule",
    "campaigns:manage",
    "templates:manage",
    "segments:manage",
    "subscribers:manage",
    "branding:manage",
];
const ANALYST = ["reports:view"];
const SUPPORT = ["reports:view", "subscribers:manage"];
const ALL = [
    "reports:view",
    "campaigns:schedule",
    "campaigns:manage",
    "templates:manage",
    "segments:manage",
    "subscribers:manage",
    "subscribers:delete",
    "newsletters:close",
    "branding:manage",
    "suppression:manage",
    "alerts:manage",
    "identity:manage",
    "apikeys:manage",
    "team:manage",
];
export const ROLES = {
    developer_admin: new Set(ALL),
    editor: new Set(EDITOR),
    analyst: new Set(ANALYST),
    support: new Set(SUPPORT),
};
const ROLE_NAMES = new Set(["developer_admin", "editor", "analyst", "support"]);
/**
 * Build a Grant from admin-pool JWT claims (API Gateway JWT authorizer).
 * Expects `custom:role` (a RoleName) and `custom:orgs` ("*" or a comma-separated
 * list of orgIds). Throws if the role claim is missing/invalid.
 */
export function grantFromClaims(claims) {
    // Token-type confusion guard. Cognito ID tokens carry `custom:*` attributes;
    // access tokens do not. We standardize on the ID token (#161), so reject an
    // access token presented in its place. Checked only when the claim is present
    // so non-Cognito fixtures/tests remain usable — real tokens always carry it.
    const tokenUse = claims["token_use"];
    if (tokenUse !== undefined && tokenUse !== "id") {
        throw new ForbiddenError("reports:view", "*");
    }
    const role = claims["custom:role"];
    if (!role || !ROLE_NAMES.has(role)) {
        throw new ForbiddenError("reports:view", "*");
    }
    const orgsRaw = (claims["custom:orgs"] ?? "").trim();
    // Empty ⇒ no orgs (deny by default); "*" ⇒ all orgs.
    if (orgsRaw === "*")
        return { role: role, orgs: "*" };
    const parts = orgsRaw.split(",").map((o) => o.trim()).filter(Boolean);
    // "*" is a wildcard ONLY as the entire claim. A list containing it (e.g.
    // "orgA,*") must never widen scope: Cedar's set membership would have matched
    // the smuggled element and granted every org, diverging from inScope() — which
    // denies — so the two authorization paths disagreed. Reject outright.
    if (parts.includes("*"))
        throw new ForbiddenError("reports:view", "*");
    return { role: role, orgs: parts };
}
export function can(role, capability) {
    return ROLES[role].has(capability);
}
export function inScope(grant, orgId) {
    return grant.orgs === "*" || grant.orgs.includes(orgId);
}
export class ForbiddenError extends Error {
    capability;
    orgId;
    constructor(capability, orgId) {
        super(`Forbidden: missing ${capability} for org ${orgId}`);
        this.capability = capability;
        this.orgId = orgId;
        this.name = "ForbiddenError";
    }
}
//# sourceMappingURL=roles.js.map